import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './common.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import insuranceInfoSvg from '../../assets/insurance-info.svg';
import insuranceIconSvg from '../../assets/insurance-icon.svg';
import noDataSvg from '../../assets/no-data.svg';
import Loading from 'pages/toyotaOfficialAccount/Loading';
import Error from 'pages/toyotaOfficialAccount/Error';

import { AuthValid } from 'shared/httpHandler';
import { encodeBase64Object } from 'shared/common';
import axios from 'axios';

// const insuranceList = [
//   {
//     type: '強制險',
//     date: '2030/12/31',
//     company: '國泰產險',
//     amount: '$2,000,000',
//   },
//   {
//     type: '任意險',
//     date: '2031/02/14',
//     company: '國泰產險',
//     amount: '$1,500,000',
//   },
// ];

const InsuranceInfo = () => {
  const [token, setToken] = useState('');
  const [carNo, setCarNo] = useState('');
  const [lineId, setLineId] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [displayError, setDisplayError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    try {
      const payload = AuthValid.parseJwt(token);
      setToken(token);
      setLineId(payload.sub);
      setCarNo(payload.carNo);
    } catch (error) {
      console.error('Failed to parse JWT token:', error);
      setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
      setDisplayError(true);
    }
  }, []);

  useEffect(() => {
    if (token && lineId && carNo) {
      const getInsuranceInfo = async () => {
        try {
          const queryParams = new URLSearchParams(encodeBase64Object({
            car_no: carNo,
            auth_token: token
          }));
          const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/insurance?${queryParams.toString()}`);
          setRecords(response.data.data || []);
        } catch (error) {
          console.error('Failed to get insurance info:', error);
          if( error.status >= 400 && error.status <= 499) {
            setErrorMessage("您正前往的頁面已失效，請重新操作LINE官方帳號選單。");
          }
          setDisplayError(true);
        } finally {
          setIsLoading(false);
        }
      }
      getInsuranceInfo();
    }
  }, [token, lineId, carNo, isLoading]);

  if (isLoading) {
    return <Loading />;
  }

  if (displayError) {
    return <Error message={errorMessage} />;
  }

  return (
    <div className="center-viewport">
      <div className="maintenance-app">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>
        <div className="main-content">
          <div className="content-header">
            <div className="header-row">
              <div className="header-text">
                <div className="vehicle-number">{carNo}</div>
                <h1 className="page-title">保險資訊</h1>
              </div>
              <div className="header-icons">
                <img src={insuranceInfoSvg} alt="保險icon" className="insurance-header-icon" />
              </div>
            </div>
            <p className="description">保險名稱可能與保單不同，請依實際收到的保單內容為主。</p>
          </div>
          <div className="car-list-container">
            {records.map((record, index) => (
              <div key={index} className="card-container">
                <div className="card-title-row">
                  <img src={insuranceIconSvg} alt="保險類型icon" className="card-title-icon" />
                  <span className="text-dark font-bold text-lg">{record.ITEMS}</span>
                </div>
                <div className="section-divider" />
                <div className="flex-col">
                  <div className='flex-between text-base'>
                    <span className="text-dark-base">保險到期日</span>
                    <span className="text-dark-base font-medium">{record.ENDAT}</span>
                  </div>
                  <div className="flex-between text-base">
                    <span className="text-dark-base">保險公司</span>
                    <span className="text-dark-base font-medium">{record.INSUNM}</span>
                  </div>
                  <div className="flex-between text-base">
                    <span className="text-dark-base">保險總額</span>
                    <span className="text-dark-base font-medium">{record.ISAMT}</span>
                  </div>
                </div>
              </div>
            ))}
            {records.length === 0 && (
              <div className="card-container">
                <div className="no-data-block">
                  <img src={noDataSvg} alt="no data" className="no-data-img" />
                  <div className="text-muted-base font-medium">目前尚無資料</div>
                  <div style={{ color: '#9D9D9D', textAlign: 'center', fontFeatureSettings: '\'liga\' off, \'clig\' off', fontFamily: 'Noto Sans TC', fontSize: '14px', fontStyle: 'normal', fontWeight: '400', lineHeight: '20px', letterSpacing: '0.84px', marginTop: -8 }}>僅提供經由和安保險代理人承保相關資訊</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
} 


export default InsuranceInfo; 